import type { ThemesEvent } from '../../contract'

export type ToolEvent = Extract<ThemesEvent, { type: 'tool' }>

function describe(e: ToolEvent): { label: string; detail: string } {
  const input = (e.input ?? {}) as Record<string, unknown>
  const output = (e.output ?? {}) as Record<string, unknown>
  if (e.name === 'search_quotes') {
    const hits = typeof output.hits === 'number' ? output.hits
      : Array.isArray(output.results) ? output.results.length
      : Array.isArray(e.output) ? e.output.length : undefined
    return { label: `search_quotes “${String(input.query ?? '')}”`, detail: e.output === undefined ? '…' : hits === undefined ? '' : `${hits} hit${hits === 1 ? '' : 's'}` }
  }
  if (e.name === 'get_line') {
    const line = (typeof output.text === 'string' ? output : (output.line as Record<string, unknown> | undefined)) ?? {}
    const text = typeof line.text === 'string' ? line.text : ''
    return { label: `get_line ${String(input.lineId ?? '')}`, detail: e.output === undefined ? '…' : text ? `“${text.slice(0, 60)}${text.length > 60 ? '…' : ''}”` : 'not found' }
  }
  return { label: e.name, detail: JSON.stringify(input).slice(0, 80) }
}

/** Live list of the model's tool calls while a run streams. */
export function Ticker({ events, status, running }: { events: ToolEvent[]; status: string; running: boolean }) {
  return (
    <div className={`ticker${running ? ' ticker--live' : ''}`} data-testid="ticker" aria-live="polite">
      <div className="ticker__head">
        <span className={`dot${running ? ' dot--live' : ''}`} aria-hidden />
        <span className="ticker__status">{status}</span>
        <span className="ticker__count">{events.length} tool call{events.length === 1 ? '' : 's'}</span>
      </div>
      <ol className="ticker__list">
        {events.map((e, i) => {
          const d = describe(e)
          return (
            <li key={i} className="ticker__item" data-testid="ticker-item">
              <span className="ticker__label mono">{d.label}</span>
              {d.detail && <span className="ticker__detail">{d.detail}</span>}
            </li>
          )
        })}
      </ol>
    </div>
  )
}
